import React from 'react';
import { Box } from '@mui/material';
import StyledProgressLine from './ProgressLine.styled';
import StyledProgressContainer from './ProgressContainer.styled';

interface SummaryProgressProps {
  plannedWorkingHours: number;
  loggedWorkingHours: number;
  holidaysHours: number;
}

export default function SummaryProgress({
  plannedWorkingHours,
  loggedWorkingHours,
  holidaysHours,
}: SummaryProgressProps) {
  const fullPercentageValue =
    plannedWorkingHours > holidaysHours + loggedWorkingHours
      ? plannedWorkingHours
      : holidaysHours + loggedWorkingHours;

  const holidaysPercentage = (holidaysHours / fullPercentageValue) * 100;
  const loggedPercentage = (loggedWorkingHours / fullPercentageValue) * 100;

  return (
    <Box px={3}>
      <StyledProgressContainer>
        <StyledProgressLine
          zIndex={100}
          width={`${holidaysPercentage}%`}
          left={0}
          bgcolor="primary.lightDark"
        />
        <StyledProgressLine
          left={`${holidaysPercentage}%`}
          width={`${loggedPercentage}%`}
          bgcolor="warning.light"
        />
      </StyledProgressContainer>
    </Box>
  );
}
